import { Activity } from './activity.model'
import { Lecturer } from './lecturer.model'
import { Area } from './area.model';

export class AreaProgram {
    public Area: Area;
    public Atividades: Array<Activity>;
    public Palestrantes: Array<Lecturer>;
    public DataPermiteAvaliacaoParticipante: boolean;
    public InitAtividades: Array<Activity>;
}


// WEBPACK FOOTER //
// ./src/models/area.program.model.ts